import { Link, createFileRoute, redirect } from "@tanstack/react-router";
import { readFarewell } from "../../lib/farewell";
import { AuthBody, AuthFooter, AuthHeading, AuthPending } from "../../components/auth-card";
import { ArrowRightIcon } from "../../components/icons";

export const Route = createFileRoute("/auth/deleted")({
  // Reached once, from the Delete account dialog, which leaves a note in
  // memory on its way here (lib/farewell). Without one — a reload, the
  // address typed by hand, the way back through the history — this is just
  // a signed-out visitor: sign-in. The note is read here, where reading it
  // takes it, and handed to the page through the route's context.
  beforeLoad: () => {
    const farewell = readFarewell();
    if (!farewell) throw redirect({ to: "/auth/signin", search: { next: undefined } });
    return { farewell };
  },
  component: Deleted,
  pendingComponent: AuthPending,
});

/** The goodbye page. A signed-out page like every other under /auth: it
 * names no server — a count decides one line, and that is all it knows. */
function Deleted() {
  const { farewell } = Route.useRouteContext();
  return (
    <>
      <AuthBody>
        <AuthHeading title="Account deleted">
          Your account and everything in it are gone.
        </AuthHeading>
        <div className="flex flex-col gap-3 text-center text-[14px] leading-normal text-balance text-[var(--rago-text-3)]">
          {farewell.ownedServers === 1 ? (
            <p>
              Your server is removed from the account. Its libraries and files are still on disk,
              and it can be set up again from its setup page.
            </p>
          ) : farewell.ownedServers > 1 ? (
            <p>
              Your servers are removed from the account. Their libraries and files are still on
              disk, and each can be set up again from its setup page.
            </p>
          ) : null}
          <p>A confirmation is on its way to your email.</p>
        </div>
        <Link
          to="/auth/signup"
          search={{ next: undefined }}
          className="rago-btn rago-btn-block rago-btn-lg"
        >
          Create an account
        </Link>
      </AuthBody>
      <AuthFooter prompt="Have another account?">
        <Link to="/auth/signin" search={{ next: undefined }} className="rago-auth-switch">
          Sign in
          <ArrowRightIcon size={13} bold />
        </Link>
      </AuthFooter>
    </>
  );
}
